const Data = {
  productItems: [
    {
      id: 1,
      discount: 50,
      cover:
        "https://ds.rokomari.store/rokomari110/ProductNew20190903/260X372/Dui_Bon-Rabindranath_Tagore-3952e-175342.jpg",
      name: "দুই বোন",
      price: 100,
    },
    {
      id: 2,
      discount: 40,
      cover:
        "https://ds.rokomari.store/rokomari110/ProductNew20190903/260X372/Bodley_Dewer_Gan-Rahitul_Islam-efa1b-268196.jpg",
      name: "বদলে দেওয়ার গান",
      price: 20,
    },
    {
      id: 3,
      discount: 40,
      cover:
        "https://ds.rokomari.store/rokomari110/ProductNew20190903/260X372/The_Mughal_Aviary-Sabiha_Huq-fee91-251935.jpeg",
      name: "The Mughal Aviary",
      price: 200,
    },
    {
      id: 4,
      discount: 40,
      cover:
        "https://ds.rokomari.store/rokomari110/ProductNew20190903/260X372/Project_Lovecraft_1-Lutful_Kaisar-edeca-252502.jpg",
      name: "প্রজেক্ট লাভক্র্যাফট ১",
      price: 50,
    },
    {
      id: 5,
      discount: 50,
      cover:
        "https://ds.rokomari.store/rokomari110/ProductNew20190903/260X372/c5b8dba32_210999.jpg",
      name: "প্রোডাক্টিভ মুসলিমাহ ডেইলি প্ল্যানার ",
      price: 100,
    },
    {
      id: 6,
      discount: 50,
      cover:
        "https://ds.rokomari.store/rokomari110/ProductNew20190903/260X372/Dena_Paona-Saratchandra_Chattopadhyay-c7b1b-176024.jpg",
      name: "দেনা-পাওনা",
      price: 100,
    },
  ],
};
export default Data;
